export type Row = {
  key: string;
  kind: string;
  name: string;
  usd: number;
  /** undefined = no override, use the default; number = today's limit; null = uncapped. */
  limitUsd: number | null | undefined;
  suspended: boolean;
};

export function effectiveLimit(r: Row, defaultThresholdUsd: number): number | null {
  return r.limitUsd === undefined ? defaultThresholdUsd : r.limitUsd;
}

export function usagePct(r: Row, defaultThresholdUsd: number): number {
  const limit = effectiveLimit(r, defaultThresholdUsd);
  return limit === null ? 0 : (r.usd / limit) * 100;
}

export function statusOf(r: Row, defaultThresholdUsd: number): { label: string; danger: boolean } {
  if (r.suspended) return { label: "Suspended", danger: true };
  const limit = effectiveLimit(r, defaultThresholdUsd);
  if (limit !== null && r.usd >= limit) return { label: "Over limit", danger: true };
  if (r.limitUsd !== undefined) return { label: "Limit raised", danger: false };
  return { label: "Under limit", danger: false };
}

export const money = (v: number): string =>
  "$" + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
